export default __webpack_public_path__ + "static/media/Jakob_Bangsgaard.4b99744f.webp";